import { AuthModel } from './AuthModel'
import { UserAddressModel } from './UserAddressModel'
import { UserCommunicationModel } from './UserCommunicationModel'
import { UserEmailSettingsModel } from './UserEmailSettingsModel'
import { UserSocialNetworksModel } from './UserSocialNetworksModel'
import { CompanyType, TeamType } from '../types/CompanyType'

export enum UserRoleEnum {
  SecchiAdmin = 'SecchiAdmin',
  SuperAdmin = 'SuperAdmin',
  Provisioner = 'Provisioner',
  Supervisor = 'Supervisor',
	SecchiEngineerSenior = 'SecchiEngineerSenior',
}

export type UserTag = string | UserProfileTag;

export enum UserProfileTag {
  MasterProfile = 'MASTER_PROFILE',
  SlaveProfile = 'SLAVE_PROFILE',
  HasAlias = 'HAS_ALIAS',
}

export interface UserModel {
  id: number
  username: string
  email: string
  isEmailVerified: boolean
  firstName: string
  lastName: string
  fullname?: string
  occupation?: string
  company?: CompanyType
  phone?: string
  roles?: UserRoleEnum[]
  pic?: string
  avatarUrl?: string
  language?: 'en' | 'de' | 'es' | 'fr' | 'ja' | 'zh' | 'ru'
  timeZone?: string
  website?: 'https://keenthemes.com'
  emailSettings?: UserEmailSettingsModel
  auth?: AuthModel
  communication?: UserCommunicationModel
  address?: UserAddressModel
  socialNetworks?: UserSocialNetworksModel,
  teams: TeamType[]
	passwordUpdatedAt?: string;
	terminated_date?: string;
  // saved as Date, transmitted as string, so deviates from API interface
  last_login: string | null;
  tags: UserTag[];
}
